<template>
  <div>
    <UeGlobalModal
      name="share_customer_page_modal"
      title="Share Proof Page"
      :maxWidth="700"
      @before-open="beforeOpen"
    >
      <div class="form-group">
        <label class="font-weight-bold">Share Link</label>
        <UeCopyToClipboard :text="shareUrl" variant="link">
          <input class="form-control" ref="shareLink" type="text" readonly :value="shareUrl" />
        </UeCopyToClipboard>
      </div>

      <div class="form-group mt-4">
        <label class="font-weight-bold">Embed Code</label>
        <UeCopyToClipboard :text="embedHtml" variant="link">
          <textarea
            class="form-control overflow-hidden"
            ref="embedCode"
            rows="3"
            readonly
            :value="embedHtml"
          />
        </UeCopyToClipboard>
        <small class="form-text text-muted">
          This creates a fullscreen iframe that displays your content.
        </small>
      </div>
    </UeGlobalModal>
  </div>
</template>

<script lang="ts">
import UeGlobalModal from '@components/base/UeGlobalModal.vue'
import UeCopyToClipboard from '@components/base/UeCopyToClipboard.vue'

export default {
  components: {
    UeGlobalModal,
    UeCopyToClipboard,
  },
  data() {
    return {
      identifier: null as string | null,
      contentAssetId: null as string | number | null,
    }
  },
  computed: {
    shareUrl(): string {
      if (!this.identifier) return ''
      return `https://uevi.co/${this.identifier}`
    },
    embedUrl(): string {
      if (!this.contentAssetId) return ''
      return `${process.env.VUE_APP_UE_APP_URL}/assets/${this.contentAssetId}/embed`
    },
    embedHtml(): string {
      if (!this.embedUrl) return ''
      return `<iframe src="${this.embedUrl}" style="width: 100%; height: 100vh; border: none;" allowfullscreen></iframe>`
    },
  },
  methods: {
    show(params = {}) {
      this.$openModal('share_customer_page_modal', params)
    },
    close() {
      this.$closeModal('share_customer_page_modal')
    },
    beforeOpen(e) {
      this.identifier = e.params.identifier
      this.contentAssetId = e.params.contentAssetId
    },
  },
}
</script>
